var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var util = require("./util");
var colorUtil = require("./colors");
var a11y = require("./a11y");
var defaultDrawBorders = {
    top: true,
    left: true,
    right: true,
    bottom: true,
};
function PDFBlock(options, children) {
    if (Array.isArray(options)) {
        children = options;
        options = {};
    }
    options = options || {};
    this.options = options;
    this.children = children || [];
    // TODO: validate the inputs
    this.borderWidth = util.getOption(options, "borderWidth", 0);
    this.borderTopWidth = util.getOption(options, "borderTopWidth", this.borderWidth);
    this.borderLeftWidth = util.getOption(options, "borderLeftWidth", this.borderWidth);
    this.borderRightWidth = util.getOption(options, "borderRightWidth", this.borderWidth);
    this.borderBottomWidth = util.getOption(options, "borderBottomWidth", this.borderWidth);
    this.borderColor = util.getOption(options, "borderColor", "black");
    this.borderTopColor = util.getOption(options, "borderTopColor", this.borderColor);
    this.borderLeftColor = util.getOption(options, "borderLeftColor", this.borderColor);
    this.borderRightColor = util.getOption(options, "borderRightColor", this.borderColor);
    this.borderBottomColor = util.getOption(options, "borderBottomColor", this.borderColor);
    this.background = util.getOption(options, "background", "none");
    this.backgroundOpacity = util.getOption(options, "backgroundOpacity", 1);
    this.width = util.getOption(options, "width", "auto");
    this.height = util.getOption(options, "height", "auto");
    this.padding = util.getOption(options, "padding", 0);
    this.paddingLeft = util.getOption(options, "paddingLeft", this.padding);
    this.paddingRight = util.getOption(options, "paddingRight", this.padding);
    this.paddingTop = util.getOption(options, "paddingTop", this.padding);
    this.paddingBottom = util.getOption(options, "paddingBottom", this.padding);
    this.margin = util.getOption(options, "margin", 0);
    this.marginLeft = util.getOption(options, "marginLeft", this.margin);
    this.marginRight = util.getOption(options, "marginRight", this.margin);
    this.marginTop = util.getOption(options, "marginTop", this.margin);
    this.marginBottom = util.getOption(options, "marginBottom", this.margin);
    this.columnCount = util.getOption(options, "columnCount", 1);
    this.columnGap = util.getOption(options, "columnGap", 0);
    this.columnFill = util.getOption(options, "columnFill", "balance");
    this.avoidBreakInside = util.getOption(options, "avoidBreakInside", false);
    this.avoidBreakBefore = util.getOption(options, "avoidBreakBefore", false);
    this.overflowHidden = util.getOption(options, "overflowHidden", false);
    this.lang = util.getOption(options, "lang", null);
    this.a11y = util.getOption(options, "a11y", {});
    this.a11yBox = util.getOption(options, "a11yBox", {});
    this.drawHook = util.getOption(options, "drawHook", null);
    this.role = util.getOption(options, "role", null);
    this.ref = util.getOption(options, "ref", null);
    this.mixinHook = util.getOption(options, "mixinHook", null);
    if (typeof this.mixinHook === "function") {
        this.mixinHook(this);
    }
    this.cache = new util.CalcCache();
}
util.definePercentageProp(PDFBlock.prototype, "width", function (cursor, pct) { return cursor.width * pct; });
util.definePercentageProp(PDFBlock.prototype, "height", function (cursor, pct) { return cursor.height * pct; });
PDFBlock.prototype.invalidate = function () {
    this.cache.clear();
    this.children.forEach(function (child) {
        if (typeof child.invalidate === "function")
            child.invalidate();
    });
};
PDFBlock.prototype.innerWidth = function (cursor) {
    if (this.width === "auto") {
        return (cursor.width -
            this.paddingLeft -
            this.paddingRight -
            this.marginLeft -
            this.marginRight -
            this.borderLeftWidth -
            this.borderRightWidth);
    }
    else {
        return this.width - this.paddingLeft - this.paddingRight - this.borderLeftWidth - this.borderRightWidth;
    }
};
PDFBlock.prototype.innerHeight = function (cursor) {
    if (this.height === "auto" || isNaN(this.height)) {
        return (cursor.height -
            this.paddingTop -
            this.paddingBottom -
            this.marginTop -
            this.marginBottom -
            this.borderTopWidth -
            this.borderBottomWidth);
    }
    else {
        return this.height - this.paddingTop - this.paddingBottom - this.borderTopWidth - this.borderBottomWidth;
    }
};
PDFBlock.prototype.boxWidth = function (cursor) {
    if (this.width === "auto") {
        return cursor.width - this.marginLeft - this.marginRight;
    }
    else {
        return this.width + this.paddingLeft + this.paddingRight + this.borderLeftWidth + this.borderRightWidth;
    }
};
PDFBlock.prototype.boxHeight = function (_innerHeight) {
    if (this.height === "auto" || isNaN(this.height)) {
        return _innerHeight + this.paddingTop + this.paddingBottom + this.borderTopWidth + this.borderBottomWidth;
    }
    else {
        return this.height;
    }
};
PDFBlock.prototype.outerWidth = function (cursor) {
    if (this.width === "auto") {
        return cursor.width;
    }
    else {
        return this.width + this.marginLeft + this.marginRight;
    }
};
PDFBlock.prototype.outerHeight = function (_innerHeight) {
    if (this.height === "auto" || isNaN(this.height)) {
        return (_innerHeight +
            this.paddingTop +
            this.paddingBottom +
            this.marginTop +
            this.marginBottom +
            this.borderTopWidth +
            this.borderBottomWidth);
    }
    else {
        return this.height + this.marginTop + this.marginBottom;
    }
};
PDFBlock.prototype.getChildCursor = function (cursor) {
    var numCols = this.columnCount;
    var w = this.innerWidth(cursor);
    if (numCols > 1) {
        w = Math.max(0, (w + this.columnGap) / numCols - this.columnGap);
    }
    return {
        x: cursor.x + this.paddingLeft + this.marginLeft + this.borderLeftWidth,
        y: cursor.y + this.paddingTop + this.marginTop + this.borderTopWidth,
        width: w,
        height: this.innerHeight(cursor),
        doc: cursor.doc,
    };
};
PDFBlock.prototype.collapsedOuterWidth = function (childrenCollapsedWidth) {
    if (this.width === "auto") {
        return (childrenCollapsedWidth +
            this.paddingLeft +
            this.paddingRight +
            this.borderLeftWidth +
            this.borderRightWidth +
            this.marginLeft +
            this.marginRight);
    }
    else {
        return (this.width +
            this.paddingLeft +
            this.paddingRight +
            this.borderLeftWidth +
            this.borderRightWidth +
            this.marginLeft +
            this.marginRight);
    }
};
function hashCursor(cursor) {
    return cursor.width + !!cursor._firstOfPage;
}
PDFBlock.prototype.clone = function (overrides) {
    var ret = util.extend(Object.create(this.constructor.prototype), this, overrides);
    ret.cache = new util.CalcCache();
    return ret;
};
PDFBlock.prototype.splitTop = function (children) {
    return this.clone({
        marginBottom: 0,
        paddingBottom: 0,
        borderBottomWidth: 0,
        children: children || [],
        splitLocation: this.splitLocation === "top" ? "middle" : "top",
    });
};
PDFBlock.prototype.splitBottom = function (children) {
    return this.clone({
        marginTop: 0,
        paddingTop: 0,
        borderTopWidth: 0,
        avoidBreakBefore: false,
        children: children || [],
        splitLocation: "bottom",
    });
};
PDFBlock.prototype.splitMiddle = function (children) {
    return this.clone({
        marginTop: 0,
        paddingTop: 0,
        borderTopWidth: 0,
        marginBottom: 0,
        paddingBottom: 0,
        borderBottomWidth: 0,
        avoidBreakBefore: false,
        children: children || [],
        splitLocation: "middle",
    });
};
PDFBlock.prototype.splitChildren = function () {
    var sets = [];
    this.children.forEach(function (child) {
        if (child.absolute)
            return;
        var childSplit;
        if (typeof child.split === "function" && !child.avoidBreakInside) {
            childSplit = child.split();
        }
        else {
            childSplit = [child];
        }
        if (sets.length > 0 && child.avoidBreakBefore) {
            sets[sets.length - 1].push(childSplit.shift());
        }
        sets = sets.concat(childSplit.map(function (c) {
            return [c];
        }));
    });
    return sets;
};
PDFBlock.prototype.splitColumns = function () {
    // eslint-disable-next-line no-console
    console.warn("Columns cannot be split!");
    return [this];
};
PDFBlock.prototype.split = function () {
    if (this.columnCount && this.columnCount !== 1) {
        return this.splitColumns();
    }
    var sets = this.splitChildren();
    if (sets.length <= 1)
        return [this];
    var first = this.splitTop(sets.shift());
    var last = this.splitBottom(sets.pop());
    var that = this;
    var ret = [first].concat(sets.map(function (s) {
        return that.splitMiddle(s);
    }), last);
    return ret;
};
function canBreakInside(n) {
    if (typeof n.splitToHeight !== "function")
        return false;
    if (n.avoidBreakInside)
        return false;
    // if (typeof n.columnCount === "number" && n.columnCount > 1) return false;
    if (Array.isArray(n.children) && n.children.length === 1 && n.children[0].text)
        return false;
    return true;
}
PDFBlock.prototype._splitToHeight = function (cursor) {
    if (this.children.length === 0) {
        if (this.splitLocation === "bottom")
            return [this];
        else
            return [this.splitTop(), this.splitBottom()];
    }
    var numColumns = typeof this.columnCount === "number" ? this.columnCount : 1;
    var top = this.splitTop();
    var remainingChildren = this.children.slice();
    for (var c = 0; c < numColumns; c++) {
        var childCursor = top.getChildCursor(cursor);
        for (var i = 0; remainingChildren.length > 0; i++) {
            var child = remainingChildren.shift();
            if (child.absolute) {
                top.children.push(child);
                top.cache.clear();
                continue;
            }
            childCursor._firstOfPage = cursor._firstOfPage && i === 0;
            childCursor._lastOfPage = cursor._lastOfPage && i === this.children.length - 1;
            var measure = child.calc(childCursor);
            if (measure.height > childCursor.height) {
                if (canBreakInside(child)) {
                    var _a = child.splitToHeight(childCursor, true), first = _a[0], rest = _a[1];
                    top.children.push(first);
                    top.cache.clear();
                    if (rest) {
                        remainingChildren.unshift(rest);
                    }
                }
                else if (childCursor._firstOfPage) {
                    top.children.push(child);
                    top.cache.clear();
                }
                else {
                    remainingChildren.unshift(child);
                    var n = child;
                    while (top.children.length && n && n.avoidBreakBefore) {
                        n = top.children.pop();
                        remainingChildren.unshift(n);
                    }
                }
                break;
            }
            top.children.push(child);
            top.cache.clear();
            childCursor.y += measure.height;
            childCursor.height -= measure.height;
        }
    }
    return [top, this.splitBottom(remainingChildren)];
};
PDFBlock.prototype.splitToHeight = function (cursor, noRecursive) {
    var measure = this.calc(cursor);
    if (measure.height <= cursor.height || !canBreakInside(this)) {
        return [this];
    }
    if (noRecursive) {
        return this._splitToHeight(cursor);
    }
    var result = [];
    var _a = this._splitToHeight(cursor), first = _a[0], rest = _a[1];
    result.push(first);
    var toSplit = rest;
    while (toSplit) {
        var _b = toSplit.splitToHeight(cursor, true), next = _b[0], rest_1 = _b[1];
        result.push(next);
        toSplit = rest_1;
    }
    return result;
};
PDFBlock.prototype._printDebug = function (indent) {
    return __spreadArray([
        "<".concat(this.constructor.name).concat(this.avoidBreakInside ? " avoidBreakInside" : "").concat(this.columnCount > 1 ? " columnCount=".concat(this.columnCount) : "").concat(this.splitLocation ? " splitLocation=".concat(this.splitLocation) : "", ">")
    ], this.children.flatMap(function (c) {
        return typeof c._printDebug === "function" ? c._printDebug("  ") : "  <".concat(c.constructor.name, ">");
    }), true).map(function (v) { return indent + v; });
};
PDFBlock.prototype.printDebug = function (cursor) {
    /* eslint-disable no-console */
    console.log("---\nPRINTDEBUG\n");
    console.log(this.ref);
    if (cursor)
        console.log(cursor);
    console.log(this._printDebug("").join("\n"));
    console.log("---");
    /* eslint-enable no-console */
};
function splitHeights(heights, h) {
    var cols = [], currentHeight = 0, tmpHeight = 0, firstInCol = 0;
    for (var i = 0; i < heights.length; i++) {
        tmpHeight = currentHeight + heights[i];
        if (tmpHeight > h) {
            cols.push(i - firstInCol);
            firstInCol = i;
            tmpHeight = heights[i];
        }
        currentHeight = tmpHeight;
    }
    if (firstInCol < heights.length)
        cols.push(heights.length - firstInCol);
    return cols;
}
function getColumns(heights, h) {
    return splitHeights(heights, h).length;
}
function getColumnHeightBalanced(childHeights, numCol) {
    if (childHeights.length === 0)
        return 0;
    var max = childHeights.reduce(function (a, b) {
        return a + b;
    });
    var min = childHeights.reduce(function (a, b) {
        return Math.max(a, b);
    });
    if (min <= 0)
        return 0;
    var minCol = getColumns(childHeights, min);
    if (minCol <= numCol)
        return min;
    var maxCol = getColumns(childHeights, max);
    var tmp, tmpCol;
    while (minCol !== numCol || maxCol !== numCol) {
        if (max - min < 0.05)
            return max;
        tmp = (max - min) / 2 + min;
        tmpCol = getColumns(childHeights, tmp);
        if (tmpCol <= numCol) {
            max = tmp;
            maxCol = tmpCol;
        }
        else {
            min = tmp;
            minCol = tmpCol;
        }
    }
    return min;
}
PDFBlock.prototype.calc = function (cursor) {
    this.__cursor = cursor;
    if (this.cache.has(hashCursor(cursor))) {
        return this.cache.get(hashCursor(cursor));
    }
    var childCursor = this.getChildCursor(cursor), ret, _innerHeight = 0, measure, baseline, firstBaseline, childrenCollapsedWidth = 0, childHeights = [], _columns;
    for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].absolute)
            continue;
        childCursor._firstOfPage = cursor._firstOfPage && i === 0;
        childCursor._lastOfPage = cursor._lastOfPage && i === this.children.length - 1;
        measure = this.children[i].calc(childCursor);
        if (measure._collapsedWidth)
            childrenCollapsedWidth = Math.max(childrenCollapsedWidth, measure._collapsedWidth);
        else
            childrenCollapsedWidth = Math.max(childrenCollapsedWidth, measure.width);
        if (typeof measure.baseline === "number") {
            baseline = measure.baseline + (childCursor.y - cursor.y);
        }
        if (typeof measure.firstBaseline === "number" && typeof firstBaseline !== "number") {
            firstBaseline = measure.firstBaseline + (childCursor.y - cursor.y);
        }
        childHeights.push(measure.height);
        _innerHeight += measure.height;
        childCursor.y += measure.height;
    }
    if (this.columnCount > 1) {
        if (this.columnFill === "auto" && this.height !== "auto") {
            _innerHeight = Math.min(this.innerHeight(cursor), _innerHeight);
        }
        else {
            _innerHeight = getColumnHeightBalanced(childHeights, this.columnCount);
        }
        _columns = splitHeights(childHeights, _innerHeight);
    }
    ret = {
        width: this.outerWidth(cursor),
        height: this.outerHeight(_innerHeight),
        _innerHeight: _innerHeight,
        _columns: _columns,
        baseline: baseline,
        firstBaseline: firstBaseline,
        _collapsedWidth: this.collapsedOuterWidth(childrenCollapsedWidth),
    };
    // Absolute Children
    childCursor = {
        x: cursor.x,
        y: cursor.y,
        width: this.boxWidth(cursor),
        height: this.boxHeight(_innerHeight),
        doc: cursor.doc,
    };
    for (i = 0; i < this.children.length; i++) {
        if (!this.children[i].absolute)
            continue;
        this.children[i].calc(childCursor);
    }
    this.cache.set(hashCursor(cursor), ret);
    return ret;
};
PDFBlock.prototype.drawBackground = function (cursor, box, measure) {
    if (typeof cursor._drawBorders !== "undefined" && !cursor._drawBorders)
        return;
    var borderCorrection = {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
    };
    if (this.borderLeftWidth > 0) {
        borderCorrection.left = this.borderLeftWidth / 2;
        borderCorrection.right = this.borderLeftWidth / 2;
    }
    if (this.borderRightWidth > 0) {
        borderCorrection.right += this.borderRightWidth / 2;
    }
    if (this.borderTopWidth > 0) {
        borderCorrection.top = this.borderTopWidth / 2;
        borderCorrection.bottom = this.borderTopWidth / 2;
    }
    if (this.borderBottomWidth > 0) {
        borderCorrection.bottom += this.borderBottomWidth / 2;
    }
    var doc = cursor.doc;
    if (measure)
        measure = this.calc(cursor);
    if (!box) {
        box = {
            x: cursor.x + this.marginLeft + borderCorrection.left,
            y: cursor.y + this.marginTop + borderCorrection.top,
            width: this.boxWidth(cursor) - borderCorrection.right,
            height: this.boxHeight(measure._innerHeight) - borderCorrection.bottom,
        };
    }
    else {
        box = {
            x: box.x + borderCorrection.left,
            y: box.y + borderCorrection.top,
            width: box.width - borderCorrection.right,
            height: box.height - borderCorrection.bottom,
        };
    }
    if (this.background !== "none" && box.height > 0 && box.width > 0) {
        a11y.artifact(cursor, function () {
            doc.setFillColor.apply(doc, colorUtil.getRGB(this.background));
            if (this.backgroundOpacity < 1)
                doc.setFillOpacity(this.backgroundOpacity);
            doc.rect(box.x, box.y, box.width, box.height, "F");
            if (this.backgroundOpacity < 1)
                doc.setFillOpacity(1);
        }, this);
    }
};
PDFBlock.prototype.drawBorders = function (cursor, box, measure) {
    if (typeof cursor._drawBorders !== "undefined" && !cursor._drawBorders)
        return;
    var doc = cursor.doc;
    if (measure)
        measure = this.calc(cursor);
    if (!box)
        box = {
            x: cursor.x + this.marginLeft,
            y: cursor.y + this.marginTop,
            width: this.boxWidth(cursor),
            height: this.boxHeight(measure._innerHeight),
        };
    var _drawBorders = (function () {
        if (!cursor._drawBorders || typeof cursor._drawBorders !== "object")
            return defaultDrawBorders;
        else
            return cursor._drawBorders;
    })();
    if ((this.borderTopWidth <= 0 || !_drawBorders.top) &&
        (this.borderRightWidth <= 0 || !_drawBorders.right) &&
        (this.borderBottomWidth <= 0 || !_drawBorders.bottom) &&
        (this.borderLeftWidth <= 0 || !_drawBorders.left)) {
        return;
    }
    a11y.artifact(cursor, function () {
        if (this.borderTopWidth > 0 && _drawBorders.top) {
            // inset = this.borderTopWidth / 2;
            // doc.setDrawColor.apply(doc, colorUtil.getRGB(this.borderTopColor));
            // doc.setLineWidth(this.borderTopWidth);
            // doc.line(box.x, box.y + inset, box.x + box.width, box.y + inset);
            doc.setFillColor.apply(doc, colorUtil.getRGB(this.borderTopColor));
            doc.rect(box.x, box.y, box.width, this.borderTopWidth, "F");
        }
        if (this.borderRightWidth > 0 && _drawBorders.right) {
            // inset = this.borderRightWidth / 2;
            // doc.setDrawColor.apply(doc, colorUtil.getRGB(this.borderRightColor));
            // doc.setLineWidth(this.borderRightWidth);
            // doc.line(box.x + box.width - inset, box.y, box.x + box.width - inset, box.y + box.height);
            doc.setFillColor.apply(doc, colorUtil.getRGB(this.borderRightColor));
            doc.rect(box.x + box.width - this.borderRightWidth, box.y, this.borderRightWidth, box.height, "F");
        }
        if (this.borderBottomWidth > 0 && _drawBorders.bottom) {
            // inset = this.borderBottomWidth / 2;
            // doc.setDrawColor.apply(doc, colorUtil.getRGB(this.borderBottomColor));
            // doc.setLineWidth(this.borderBottomWidth);
            // doc.line(box.x, box.y + box.height - inset, box.x + box.width, box.y + box.height - inset);
            doc.setFillColor.apply(doc, colorUtil.getRGB(this.borderBottomColor));
            doc.rect(box.x, box.y + box.height - this.borderBottomWidth, box.width, this.borderBottomWidth, "F");
        }
        if (this.borderLeftWidth > 0 && _drawBorders.left) {
            // inset = this.borderLeftWidth / 2;
            // doc.setDrawColor.apply(doc, colorUtil.getRGB(this.borderLeftColor));
            // doc.setLineWidth(this.borderLeftWidth);
            // doc.line(box.x + inset, box.y, box.x + inset, box.y + box.height);
            doc.setFillColor.apply(doc, colorUtil.getRGB(this.borderLeftColor));
            doc.rect(box.x, box.y, this.borderLeftWidth, box.height, "F");
        }
    }, this);
};
PDFBlock.prototype.draw = function (cursor) {
    var measure = this.calc(cursor), box = {
        x: cursor.x + this.marginLeft,
        y: cursor.y + this.marginTop,
        width: this.boxWidth(cursor),
        height: this.boxHeight(measure._innerHeight),
    };
    var shouldContinue = true;
    if (this.drawHook) {
        var e = {
            preventDefault: function () {
                shouldContinue = false;
            },
        };
        this.drawHook.call(this, e, cursor, box);
        if (!shouldContinue)
            return;
    }
    this.drawBackground(cursor, box, measure);
    this.drawBorders(cursor, box, measure);
    var childCursor = this.getChildCursor(cursor), measureChild;
    function drawChildren() {
        var i;
        // Absolute Children
        var absoluteChildCursor = {
            x: cursor.x,
            y: cursor.y,
            width: this.boxWidth(cursor),
            height: this.boxHeight(measure._innerHeight),
            doc: cursor.doc,
        };
        var savedFontSize = cursor.doc.getFontSize();
        var savedFont = cursor.doc.getFont();
        if (this.overflowHidden) {
            // debugger;
            cursor.doc.saveGraphicsState();
            cursor.doc
                .rect(cursor.x, cursor.y, absoluteChildCursor.width, absoluteChildCursor.height, null)
                .clip()
                .discardPath();
            // const canvas = cursor.doc.canvas;
            // ctx = canvas.getContext("2d");
            // ctx.save();
            // ctx.beginPath();
            // ctx.moveTo(cursor.x, cursor.y);
            // ctx.lineTo(cursor.x + absoluteChildCursor.width, cursor.y);
            // ctx.lineTo(cursor.x + absoluteChildCursor.width, cursor.y + absoluteChildCursor.height);
            // ctx.lineTo(cursor.x, cursor.y + absoluteChildCursor.height);
            // // ctx.rect(cursor.x, cursor.y, absoluteChildCursor.width, absoluteChildCursor.height);
            // ctx.clip();
        }
        if (measure._columns) {
            var cl = 0;
            i = 0;
            for (var c = 0; c < measure._columns.length; c++) {
                cl = cl + measure._columns[c];
                childCursor = this.getChildCursor(cursor);
                childCursor._firstOfPage = cursor._firstOfPage;
                childCursor._lastOfPage = cursor._lastOfPage;
                childCursor.x = childCursor.x + (childCursor.width + this.columnGap) * c;
                for (; i < cl; i++) {
                    measureChild = this.children[i].draw(childCursor);
                    childCursor.y += measureChild.height;
                }
            }
        }
        else {
            for (i = 0; i < this.children.length; i++) {
                if (this.children[i].absolute) {
                    this.children[i].draw(absoluteChildCursor);
                }
                else {
                    childCursor._firstOfPage = cursor._firstOfPage && i === 0;
                    childCursor._lastOfPage = cursor._lastOfPage && i === this.children.length - 1;
                    measureChild = this.children[i].draw(childCursor);
                    childCursor.y += measureChild.height;
                }
            }
        }
        if (this.overflowHidden) {
            // cursor.doc.restoreGraphicsState();
            // ctx.restore();
            cursor.doc.setFontSize(savedFontSize);
            cursor.doc.setFont(savedFont.fontName, savedFont.fontStyle);
            cursor.doc.restoreGraphicsState();
        }
    }
    if (this.role) {
        var a11yOptions = this.a11y || {};
        if (this.a11yBox) {
            a11yOptions.attr = {
                O: "/Layout",
                BBox: cursor.doc.convertBBox(box.x, box.y, box.width, box.height),
            };
        }
        a11yOptions.lang = this.lang;
        if (this.a11yAttr)
            a11yOptions.attr = this.a11yAttr;
        a11y.structure(cursor, this.role, a11yOptions, drawChildren, this);
    }
    else
        drawChildren.call(this);
    var ret = {
        width: this.outerWidth(cursor),
        height: this.outerHeight(measure._innerHeight),
        baseline: measure.baseline,
        firstBaseline: measure.firstBaseline,
        _collapsedWidth: measure._collapsedWidth,
    };
    return ret;
};
module.exports = PDFBlock;
//# sourceMappingURL=module.js.map